export const PHONE_DISPLAY = "(980) 358-8323";
export const PHONE_TEL = "tel:+19803588323";
export const EMAIL = "bmd704@outlook.com";
export const EMAIL_MAILTO = "mailto:bmd704@outlook.com";
export const HOURS = "Appointments Monday – Saturday";

export const SOCIALS = {
  facebook: "https://www.facebook.com/share/1HLENEzGg8/",
  instagram: "https://www.instagram.com/bradsmobiledetailing/",
  google:
    "https://www.google.com/maps/search/Charlotte,+NC",
};

export const SERVICE_AREA =
  "Stanly County · Charlotte · Albemarle · Locust · Oakboro · Norwood · Stanfield · Concord · Gastonia · Huntersville · Matthews · Mint Hill · Cornelius · Mooresville · Kannapolis · Monroe · Indian Trail";

export const IMAGES = {
  hero: "https://www.jaxprodetailing.com/wp-content/uploads/2024/12/168050301_864419927544828_9050949821652637214_n-scaled-1.jpg",
  about1: "https://www.jaxprodetailing.com/wp-content/uploads/elementor/thumbs/129816269_801548673831954_709913285461074267_n-scaled-1-qzb4x7408mda3dwoa00hw9bws97l7eqgapvyz11lw6.jpg",
  about2: "https://www.jaxprodetailing.com/wp-content/uploads/elementor/thumbs/69718033_414512732535552_1703515661751287808_n-qzb4rbme5mj095422uebrlegxpdk0ygc39hm0u95xi.jpg",
  exterior: "https://www.jaxprodetailing.com/wp-content/uploads/2020/07/49205848_1955690691214832_7198807518187880448_n-840x473.jpg",
  interior: "https://www.jaxprodetailing.com/wp-content/uploads/2020/07/49344961_218362159046651_7670835900170895360_n-840x473.jpg",
  ceramic: "https://www.jaxprodetailing.com/wp-content/uploads/2024/12/159942630_852770455376442_7277384325305138242_n-scaled-1-840x840.jpg",
  ceo: "/founder.jpg",
};

export const VEHICLE_SIZES = [
  { id: "sedan", label: "Sedan / Coupe" },
  { id: "suv", label: "SUV / Crossover" },
  { id: "truck", label: "Truck / Large SUV" },
];

export const SERVICES = [
  {
    id: "deluxe",
    name: "STANDARD Detail Package",
    tagline: "Our essential detail package — hand wash and dry, wheels & tires, interior vacuum and wipe-down, finished with a spray wax.",
    time: "1.5–2 hrs",
    prices: { sedan: 175, suv: 175, truck: 175 },
    highlights: [
      "Hand wash and dry exterior",
      "Clean wheels, tires & wheel wells",
      "Vacuum interior, wipe & dress dash",
      "Shampoo floor mats",
      "Spray wax or sealant",
    ],
    includes: 13,
    featured: false,
    groups: [
      {
        label: "What's included",
        items: [
          "Hand Wash and Dry Exterior",
          "Clean Wheels & Tires",
          "Clean Wheel Wells",
          "Clean & Dress Tires",
          "Clean Windows",
          "Wipe & Dress Dashboard",
          "Wipe & Dress Door Panels",
          "Vacuum Interior",
          "Clean Cup Holders",
          "Air Freshener",
          "Wipe Door Jambs",
          "Shampoo Floor Mats (only)",
          "Spray Wax or Sealant",
        ],
      },
    ],
  },
  {
    id: "gold",
    name: "GOLD PLUS Detail Package",
    tagline: "Our GOLD detailing package with comprehensive INTERIOR and EXTERIOR services including shampoo and high quality wax.",
    time: "2–3 hrs",
    prices: { sedan: 275, suv: 275, truck: 275 },
    highlights: [
      "Complete outside foam wash",
      "Shampoo carpets, trunk & mats",
      "Deep clean leather or shampoo cloth seats",
      "Clean all door jambs & trunk seals",
      "High quality spray wax on all paint",
    ],
    includes: 20,
    featured: true,
    badge: "MOST POPULAR",
    groups: [
      {
        label: "— EXTERIOR SERVICES —",
        items: [
          "Complete outside foam wash",
          "Hand dry with clean microfiber towels",
          "Clean and degrease wheels and tires",
          "Dress tires, trim and moldings",
          "Clean all door jambs and trunk seals",
          "Clean exterior windows",
          "Clay bar prep all painted surfaces to remove harmful contaminants",
          "Apply high quality spray wax to all painted surfaces",
        ],
      },
      {
        label: "— INTERIOR SERVICES —",
        items: [
          "Vacuum entire interior and trunk",
          "Wipe down all interior surfaces",
          "Apply UV protector to all hard surfaces",
          "Shampoo interior carpets, trunk and floor mats",
          "Deep clean and condition leather seats OR shampoo cloth seats",
          "Wipe down any leather surfaces and apply a conditioner",
          "Spot clean head liner",
          "Clean vents",
          "Clean all interior cup holders",
          "Clean interior compartments (emptied)",
          "Clean interior windows",
          "Air Freshener",
        ],
      },
    ],
  },
  {
    id: "supergold",
    name: "SUPER GOLD PLUS",
    tagline: "Is your car a hot mess? Stains, odors, pet hair? This package gives our technician ample time and special processes to eliminate the worst interior issues.",
    time: "4 man-hrs",
    prices: { sedan: 350, suv: 425, truck: 500 },
    highlights: [
      "Everything in GOLD, doubled down",
      "Stain removal & pet hair removal",
      "Double shampoo carpets & mats",
      "Clay prep all painted surfaces",
      "High quality wax on all paint",
    ],
    includes: 25,
    featured: false,
    groups: [
      {
        label: "— EXTERIOR SERVICES —",
        items: [
          "Complete outside wash",
          "Hand dry with clean microfiber towels",
          "Clean and degrease wheels and tires",
          "Apply tire and wheel dressing",
          "Clean all door jambs and trunk seals",
          "Clean exterior windows",
          "Clay prep all painted surfaces to remove harmful contaminants",
          "Apply high quality wax to all painted surfaces",
          "Exterior dressing of plastics",
          "Engine compartment wipe-down",
        ],
      },
      {
        label: "— INTERIOR SERVICES —",
        items: [
          "Vacuum entire interior and trunk",
          "Complete wipe down",
          "Apply UV protector to all hard surfaces",
          "Double shampoo interior carpets, trunk and floor mats",
          "Double deep clean and condition leather seats OR deep clean and shampoo cloth seats",
          "Stain removal",
          "Pet hair removal",
          "Wipe down any leather surfaces and apply a conditioner",
          "Spot clean head liner",
          "Clean interior windows",
          "Clean vents",
          "Clean door jambs",
          "Clean all cup holders",
          "Clean empty interior compartments",
          "Air Freshener",
        ],
      },
    ],
  },
  {
    id: "interior",
    name: "SUPER INTERIOR (only)",
    tagline: "Is your interior super dirty? Heavy stains, odors, pet hair? This package will have your interior look and smell really great.",
    time: "3 man-hrs",
    prices: { sedan: 200, suv: 325, truck: 450 },
    highlights: [
      "Vacuum entire interior & trunk",
      "UV protector on all hard surfaces",
      "Double shampoo carpets & mats",
      "Stain & pet hair removal",
      "Deep clean + condition leather",
    ],
    includes: 14,
    featured: false,
    groups: [
      {
        label: "What's included",
        items: [
          "Vacuum entire interior and trunk",
          "Complete wipe down",
          "Apply UV protector to all hard surfaces",
          "Double shampoo interior carpets, trunk and floor mats",
          "Double deep clean and condition leather seats OR deep clean and shampoo cloth seats",
          "Stain removal",
          "Pet hair removal",
          "Wipe down any leather surfaces and apply a conditioner",
          "Spot clean head liner",
          "Clean vents",
          "Clean door jambs",
          "Clean all cup holders",
          "Clean interior compartments (emptied)",
          "Air Freshener",
        ],
      },
    ],
  },
  {
    id: "exterior",
    name: "SUPER EXTERIOR (only)",
    tagline: "Full exterior revival — foam wash, clay decontamination & ceramic wax sealant.",
    time: "2 man-hrs",
    prices: { sedan: 85, suv: 85, truck: 85 },
    highlights: [
      "Complete outside foam wash",
      "Safely remove bugs & grime",
      "Clay bar decontamination",
      "Ceramic wax / sealant applied",
      "Dress tires, wheels & plastics",
    ],
    includes: 10,
    featured: false,
    groups: [
      {
        label: "What's included",
        items: [
          "Complete outside foam wash",
          "Safely remove bugs",
          "Clean and degrease wheels and tires",
          "Clay bar for paint decontamination",
          "Hand dry with clean microfiber towels",
          "Clean all door jambs and trunk seals",
          "Clean exterior windows",
          "Apply high quality Ceramic Wax / Sealant",
          "Dress exterior plastics",
          "Apply tire and wheel dressing",
        ],
      },
    ],
  },
];

export const ADDONS = [
  { id: "golfcart", name: "Golf Cart Cleaning", price: 100 },
  { id: "headlight", name: "Headlight Restoration", price: 60 },
  { id: "engine", name: "Engine Bay Detail", price: 85 },
  { id: "leather", name: "Leather Conditioning", price: 60 },
  { id: "odor", name: "Odor Elimination Treatment", price: 100 },
  { id: "pinstripes", name: "Pinstripes", price: 70 },
  { id: "headliner", name: "Full Headliner Deep Clean", price: 100 },
];

export const TIME_SLOTS = (() => {
  const slots = [];
  for (let m = 8 * 60; m <= 17 * 60; m += 15) {
    const h24 = Math.floor(m / 60);
    const min = m % 60;
    const ampm = h24 >= 12 ? "PM" : "AM";
    const h = h24 % 12 === 0 ? 12 : h24 % 12;
    slots.push(`${h}:${String(min).padStart(2, "0")} ${ampm}`);
  }
  return slots;
})();

export const PAYPAL = "https://www.paypal.me/jaxprodetailing";

export const GIFT_IMAGE = "https://static.prod-images.emergentagent.com/jobs/b9c0d577-4cfb-40ba-a212-8d8d2e917313/images/5167f7ba1b317141024c9cee1da71690e844a1d92ad54428e396de39e7f8984a.jpeg";

export const GALLERY_IMAGES = [
  { src: "/gallery/coach.jpg", alt: "Brad coaching Little League — proud community sponsor" },
  { src: "/gallery/owner-2.jpg", alt: "Brad hand-washing an RV motorhome — Brad's Mobile Detailing at work" },
  { src: "/gallery/owner-3.jpg", alt: "RV detail in progress — foam wash on a motorhome" },
  { src: "/gallery/owner-4.jpg", alt: "Gray Corvette with a deep-gloss finish after detail" },
  { src: "/gallery/owner-5.jpg", alt: "Corvette interior detail — tan leather cockpit" },
  { src: "/gallery/owner-1.jpg", alt: "RAM 5500 work truck detailed and shining" },
  { src: "/gallery/work-1.jpg", alt: "Black Ford F-250 after full detail" },
  { src: "/gallery/work-2.jpg", alt: "Wet-look gloss — black SUV front end after detail" },
  { src: "/gallery/work-3.jpg", alt: "Interior detail — black leather, wheels and tires dressed" },
  { src: "/gallery/detail-1.jpg", alt: "Machine polishing a black car to a mirror finish" },
  { src: "/gallery/detail-2.jpg", alt: "Front-end polish — deep gloss on black paint" },
  { src: "/gallery/detail-3.jpg", alt: "Hand polishing detail work in progress" },
  { src: "/gallery/detail-4.jpg", alt: "Polisher bringing paint back to life" },
  { src: "/gallery/detail-5.jpg", alt: "Interior detail — black leather cockpit" },
  { src: "/gallery/detail-6.jpg", alt: "Convertible interior detail — tan leather" },
  { src: "/gallery/detail-7.jpg", alt: "Leather seats cleaned and conditioned" },
  { src: "https://www.jaxprodetailing.com/wp-content/uploads/2024/12/70117599_414512802535545_1871932212874575872_n-scaled-1.jpg", alt: "Porsche Symbol" },
  { src: "https://www.jaxprodetailing.com/wp-content/uploads/2024/12/132089792_811465279506960_2319081882304110652_n-scaled-1.jpg", alt: "Tesla After Wash" },
  { src: "https://www.jaxprodetailing.com/wp-content/uploads/2025/09/2025-09-18-12_44_03-car-wash-stock-site-home-page-video.mp4-VLC-media-player.png", alt: "Audi after wash" },
  { src: "https://www.jaxprodetailing.com/wp-content/uploads/2025/09/Battalion-Cheif-SUV-After-wash.jpg", alt: "Battalion Chief SUV After wash" },
  { src: "https://www.jaxprodetailing.com/wp-content/uploads/2024/12/143177285_831076787545809_6572219154002618310_n-scaled-1-e1758218480554.jpg", alt: "Detailed vehicle" },
  { src: "https://www.jaxprodetailing.com/wp-content/uploads/2024/12/127192013_795125804474241_5169963415896703825_n-scaled-1-e1758218460452.jpg", alt: "Detailed vehicle" },
  { src: "https://www.jaxprodetailing.com/wp-content/uploads/2024/12/162457206_859176388069182_877506344571963500_n-scaled-1.jpg", alt: "Detailed vehicle" },
  { src: "https://www.jaxprodetailing.com/wp-content/uploads/2024/12/160664519_857219848264836_946282160653151176_n-scaled-1-e1758218380794.jpg", alt: "Detailed vehicle" },
  { src: "https://www.jaxprodetailing.com/wp-content/uploads/2024/12/165219800_863420234311464_1067584168710256788_n-scaled-1-988x1024.jpg", alt: "Detailed vehicle" },
];

export const PROMOS = [
  {
    id: "first-time",
    title: "$20 Off First Detail",
    description: "New to Brad's? Take $20 off your first full detail — any package, any vehicle.",
    tag: "First-time customers",
  },
  {
    id: "multi-vehicle",
    title: "Multi-Vehicle Savings",
    description: "Book two or more vehicles for the same visit and save 10% on the total.",
    tag: "Same-day bookings",
  },
  {
    id: "referral",
    title: "Refer & Save",
    description: "Send a friend our way — when they book, you both get $15 off your next detail.",
    tag: "Ongoing",
  },
];

export const TESTIMONIALS = [
  {
    name: "SANDY DOREUS",
    vehicle: "2014 Scion TC",
    text: "My car is glowing from the inside out, like a pregnant woman. Never have I ever seen it look this good. It smells heavenly! This is worth every cent.",
  },
  {
    name: "ROSA LAURIANNE",
    vehicle: "2010 Toyota Corolla",
    text: "He did an amazing job with my car. My brother actually got his car done after he saw my car done by him. #greatjob",
  },
  {
    name: "VANESSA BROWN",
    vehicle: "2015 Nissan Altima",
    text: "Amazing job! He was prompt and professional. I highly recommend!",
  },
];
